<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" class="mb-5" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">Contacto</h1>
              <h3 class="font-weight-light mt-3">
                Providencia, Santiago de Chile
              </h3>
              <h3 class="font-weight-light mt-3">
                Horario de atención: Lunes a viernes de 9 a 19 Hrs.
              </h3>
              <h3 class="font-weight-light mt-3">
                Teléfonos: +56988339429 +56996747421
              </h3>
              <h3 class="font-weight-light mt-3">
                Email: contacto@abmodel.cl
              </h3>
            </v-col>
            <v-col cols="12" sm="7">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                  v-model="name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="Correo"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="phone"
                  :rules="phoneRules"
                  label="Teléfono"
                  required
                ></v-text-field>

                <v-textarea
                  v-model="textArea"
                  :rules="textAreaRules"
                  label="Mensaje"
                  required
                />

                <v-btn
                  :disabled="!valid"
                  color="primary"
                  :dark="valid"
                  rounded
                  block
                  class="mt-3"
                  @click="submit"
                  :loading="sendingEmail"
                >
                  <template v-slot:loader>
                    <v-icon>
                      fas fa-spinner fa-spin
                    </v-icon>
                    <span class="ms-2">ENVIANDO...</span>
                  </template>
                  Enviar
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg" />
    </div>
    <v-snackbar
      v-model="snackbar.enabled"
      timeout="3000"
      right
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.enabled = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}
</style>

<script>
import emailjs from "@emailjs/browser";

export default {
  data: () => ({
    sendingEmail: false,
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "El campo es obligatorio",
      (v) => (v && v.length >= 4) || "El nombre debe tener más de 4 caracteres",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "El campo es obligatorio",
      (v) => /.+@.+\..+/.test(v) || "El correo debe ser válido",
    ],
    phone: "",
    phoneRules: [
      (v) => !!v || "El campo es obligatorio",
      (v) => /^(\+)?[0-9]+$/.test(v) || "El teléfono debe ser válido",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "El campo es obligatorio",
      (v) =>
        (v && v.length >= 10) ||
        "El mensaje debe tener como mínimo 10 caracteres",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: "",
      color: "",
    },
  }),
  methods: {
    submit() {
      this.sendingEmail = true;

      const params = {
        name: this.name,
        email: this.email,
        message: this.textArea,
        telefono: this.phone,
      };

      emailjs
        .send(
          "service_nf3wsaw",
          "template_laut04o",
          params,
          "user_LR7S6mcmo0yQJ2pr1NkIn"
        )
        .then(
          (result) => {
            this.message =
              "Se ha mandado su consulta correctamente ¡Gracias por confiar en nosotros!";

            this.$swal({
              icon: "success",
              html: `<span style="font-family:Roboto">${this.message}</span>`,
              showConfirmButton: false,
              timer: 4000,
            });

            // Reset form field
            this.name = "";
            this.email = "";
            this.phone = "";
            this.textArea = "";
            this.$refs.form.reset();
            this.sendingEmail = false;
          },
          (error) => {
            this.message =
              "Ocurrió un error enviando su consulta. Por favor, comuníquese vía telefónica";
            this.$swal({
              icon: "error",
              html: `<span style="font-family:Roboto">${this.message}</span>`,
              showConfirmButton: false,
              timer: 4000,
            });
            this.sendingEmail = false;
          }
        );
    },
  },
};
</script>
